/* eslint-disable max-len */
export default {
    ADD_TO_CART: 'Ajouter au panier',
    ADD_TO_WISHLIST: 'Ajouter à mes Favoris',
    APPLY: 'Appliquer',
    CALL_US: 'Appelez nous',
    CANCEL: 'Supprimer',
    CHOOSE_OPTION: 'Choisissez une option',
    COMPLETED: 'Terminé',
    COMPONENTS: 'Composants',
    COPY: 'Copier le lien de ma Personnalisation',
    COPIED: 'url copiée dans le presse-papiers',
    CUSTOMER_SERVICE: 'Besoin d\'aide ? Notre Service Clients est à votre écoute',
    DETAILS: 'Détails',
    DIFFERENT_SIZE: 'Différentes pointures pour chaque pied ?',
    DONE_FOR_NOW: 'Avez-vous terminé votre Personnalisation ?',
    EMAIL: 'E-mail',
    EMAIL_DESIGN: 'Envoyer ma Personnalisation par email',
    EMAIL_INVALID: 'Veuillez saisir une adresse électronique valide.',
    EMAIL_SENT: 'Nous vous remercions ! Un lien vers votre MyJoys personnalisé a été envoyé à votre ami.',
    EMAIL_SUMMARY: 'MyJoys : Résumé de l\'e-mail',
    ENTER_EMBROIDERY: 'Indiquez la broderie souhaitée',
    HELP: 'Besoin d\'aide ?',
    HOURS: 'Lundi au Vendredi, 9h à 17h',
    INVALID_ERROR: 'Ce champ contient une phrase non valide',
    MAKE_A_SELECTION: 'Faites une sélection pour continuer',
    MAX_LENGTH_6: 'Maximum 6 lettres autorisées',
    MAX_LENGTH_3: 'Maximum 3 lettres autorisées ',
    MENS: 'Homme',
    MESSAGE: 'Ecrivez',
    MESSAGE_US: 'Ecrivez nous',
    NEED_HELP: 'Besoin d\'aide ?',
    NONE_SELECTED: 'Aucune sélection',
    OK: 'Ok',
    PERSONALIZATION_POLICY: 'Politique',
    PHONE_NUMBER: '0800088135',
    PHONE_NUMBER_FORMATTED: '0800 088 135',
    PRINT: 'Imprimer ma Personnalisation',
    RECIPIENT_NAME: 'Nom du destinataire',
    RECIPIENT_EMAIL: 'E-mail du destinataire',
    REQUIRED: 'Ce champ est obligatoire',
    RESET: 'Réinitialiser',
    RESET_CONFIRM: 'Souhaitez-vous réinitialiser toutes les sélections ?',
    RESET_CONFIRM_COPY: 'Si vous continuez, toutes les sélections seront réinitialisées et votre design sera perdu.',

    SAVE: 'Enregistrer',
    SAVE_EXIT: 'ENREGISTRER & SORTIR',

    SELECT_SIZE: 'Sélectionner une pointure',
    SELECT_WIDTH: 'Sélectionner une largeur',
    LEFT_SHOE_SIZE: 'Pointure Chaussure Gauche',
    RIGHT_SHOE_SIZE: 'Pointure Chaussure Droite',

    SEND_COPY: 'Envoyer une copie de ce mail à',
    SHARE: 'PARTAGER',
    SHARE_DESIGN: 'Partager ma Personnalisation',
    SIZE_GUIDE: 'Guide des tailles',
    SUBMIT: 'Envoyer',
    UNDO: 'RETOUR',
    VIEW_ALL: 'TOUT VOIR',
    WEVE_GOT_YOU: 'Nous avons pensé à tout ! Si vous quittez cette page, vos sélections MyJoys seront enregistrées afin de pouvoir les consulter ou les continuer plus tard.',
    WOMENS: 'Femme',
    YOUR_NAME: 'Votre nom',
    YOUR_EMAIL: 'Votre e-mail',
    INSTANCE_ERROR_HEADER: 'Erreur d\'enregistrement de vos sélections.',
    INSTANCE_ERROR_BODY: 'Le service est momentanément indisponible. Merci de ré-essayer ultérieurement.',
    UPDATE_CART: 'Mettre à jour le panier',
    PERSONALIZE_CHOOSE_OPTION: 'Choisissez une option',
    PERSONALIZE_SAME_LEFT: 'Dupliquer sur le pied gauche',
    PERSONALIZE_SAME_RIGHT: 'Dupliquer sur le pied droit',
    PERSONALIZE_NONE: 'Aucune Personnalisation',
    PERSONALIZE_LOGO: 'Logos',
    PERSONALIZE_MONOGRAM: 'Initiales',
    MONOGRAM_COLOR: 'Couleur des initiales',
};
